import {
  LinkButton,
  LinkButtonType,
  Modal,
  ModalButtons,
  ModalSize,
  ModalText,
  OHeaderThree,
  OParagraph,
  Flex,
} from '@lifechurch/react-ion';
import React, { FC } from 'react';
import { useMomentTemplateQueries } from '@lib/useMomentTemplateQueries';
import { useTranslation } from 'react-i18next';

interface Props {
  id: string;
  dismiss: () => void;
}

const DeleteNextStepsTemplateModal: FC<Props> = ({ dismiss, id }) => {
  const { callDeleteMomentTemplate } = useMomentTemplateQueries();
  const { t } = useTranslation('delete_moment_template_modal');

  const handleDeleteMoment = (): void => {
    callDeleteMomentTemplate(id);
  };

  return (
    <Modal dismiss={dismiss} size={ModalSize.NARROW}>
      <OHeaderThree marginBlockEnd={3}>{t('are_you_sure')}</OHeaderThree>
      <ModalText marginBlockEnd={3}>
        <OParagraph>{t('delete_next_step_alert')}</OParagraph>
      </ModalText>
      <ModalButtons>
        <Flex justifyContent={'flex-end'} marginBlockStart={3} width={'100%'}>
          <LinkButton buttonType={LinkButtonType.SECONDARY} onClick={dismiss}>
            {t('cancel')}
          </LinkButton>
          <LinkButton
            buttonType={LinkButtonType.ERROR}
            marginInlineStart={5}
            onClick={handleDeleteMoment}
          >
            {t('delete_next_step')}
          </LinkButton>
        </Flex>
      </ModalButtons>
    </Modal>
  );
};

export default DeleteNextStepsTemplateModal;
